/**
 * common.module.js
 * 引用所有页面的共用组件、库 、逻辑
 */

// import 'dllDir/dll';
import '../iconfont/yxl-font.css'
import '../style/sass/common.scss'
import '../iconfont-ali/iconfont.css'

// 埋点函数
// import '../libs/stat/index';

import 'es6-shim'
import URLSearchParams from 'url-search-params'
import APIS from './Apis'
// if (!document.getElementsByTagName('html')[0].getAttribute('data-dpr')) {
//   require('../libs/flexible/index')
// }

if (!document.querySelector('html').getAttribute('data-dpr')) {
  require('../libs/flexible/index')
}
// import '../libs/stat/index.js';
import Stat from 'src/frontend-lib/lib/stat/Stat'
// import Monitor from 'src/frontend-lib/lib/monitor'
import { GetQueryString } from 'src/public-resource/libs/utils'
// toast
import '../components/toast/index'
// dialog
import '../components/dialog/index'
import Bridge from 'src/frontend-lib/lib/Bridge'
// import Hammer from '../libs/hammer/hammer.min';
import FixHeader from '../components/FixHeader/FixHeader'
import setHeader from '../components/header/index'
import axios from 'axios'
import { getRequestSign } from 'src/frontend-lib/tools/platformSign'
import { getPlatform } from 'src/frontend-lib/tools/getPlatform'
import PageGrayFilter from 'src/frontend-lib/component/PageGrayFilter/index'
import { trackCreator } from '@yxl/libs'

import vconsole from 'vconsole'
new vconsole()

import router from 'src/public-resource/libs/utils/router.js'

// 需要开启window.autoTrack标识的，
// 请在各自页面js导入cm模块之前，import src/pages/lesson/detail/statConfig.js。
let autotrack =
  GetQueryString('autoTrack') ||
  GetQueryString('autotrack') ||
  window.autoTrack ||
  false
window.yxl = {
  stat: new Stat({
    customTrackConfig: {
      autoTrack: autotrack // 启用全埋点采集 http://docs.zhugeio.com/dev/fullburial.html
    }
  })
}

// 神策埋点
const track = trackCreator({})

// 去除全局遮罩
let fullscreenMask = document.querySelector('#fullscreen-mask')
if (fullscreenMask) {
  fullscreenMask.parentNode.removeChild(fullscreenMask)
}

// window.yxl.stat.init({ bridge: new Bridge() });
let myBridge = new Bridge({
  methods: [
    {
      method: '_axiosGetTokenCallback',
      callback: function(options) {
        let token = options || options.token
        console.log('_axiosGetTokenCallback~', token)
      }
    }
  ]
})

window.URLSearchParams = URLSearchParams

const $platform = (window.$platform = getPlatform())
const IS_APP = $platform.isYixinliApp || $platform.isZiXunApp

const URLParams = new URLSearchParams(window.location.search)

let _token = ''

axios.interceptors.request.use(
  res => {
    // APP链接刷新token不变，故而这里需要用getToken方式去验证
    if (IS_APP) {
      return myBridge
        .call('getToken', {
          callbackName: '_axiosGetTokenCallback'
        })
        .then(obj => {
          if (typeof obj === 'object' && !!obj.token) {
            let { token } = obj
            _token = token
            if (res.url.indexOf('?') === -1) {
              res.url = res.url + '?token=' + token
            } else {
              res.url = res.url + '&token=' + token
            }
            // 重新签名
            if (res.params && res.params.sign) {
              delete res.params.sign
              res.params.token = token
              let platFormSign = getRequestSign(res.params)
              res.params = Object.assign(platFormSign.params, {
                sign: platFormSign.sign
              })
            }
          }
          return Promise.resolve(res)
        })
    } else {
      return res
    }
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  res => {
    /**
     * 后端未登录错误码有可能是40001 40002,但是40002部分是 “用户行为拦截”，比如阻止多次评论等
     * post(url, postdata, {
        disabledUnLoginInterceptors: true
      })
     * get(APIs.list, {
        params,
        disabledUnLoginInterceptors: true
      })
     */
    if (res.config.disabledUnLoginInterceptors === true) {
      return res
    }
    if (+res.data.code === 40001 || +res.data.code === 40002) {
      // TODO 未登录跳转逻辑
      window.toast('未登录，稍后为您跳转到登录页面', 3000)

      window.loginTimer = setTimeout(() => {
        let _href = ''
        if (IS_APP) {
          _href = 'yixinli://open_user_login'
          if (_token) {
            Monitor.stat({
              from: 'yimob',
              level: 'watch',
              error: 'js',
              msg: '有token却要登录',
              href: res.request._url
            })
            return res
          }
        } else {
          _href = `${APIS.login}?next=${encodeURIComponent(
            location.protocol +
              APIS.HOST +
              location.pathname +
              location.search +
              location.hash
          )}`
        }
        // window.location.href = _href
        router.openWebView(_href)
      }, 2000)

      return res
    }

    return res
  },
  err => {
    // 对响应错误做点什么
    return Promise.reject(err)
  }
)

// 操作页面置灰
PageGrayFilter()

module.exports = {
  // Hammer,
  FixHeader,
  setHeader,
  axios,
  track,
  router
}



// WEBPACK FOOTER //
// ./src/public-resource/logic/common.module.js